import {
  CameraIcon,
  DeliveryServiceIcon,
  InsuranceIcon,
  OpenBoxAndSplitIcon,
  RemoveInvoiceIcon,
  RepackageIcon,
  ReturnIcon,
  CheckParcelIcon,
  SelfPickUpIcon,
  PercentIcon,
  LimitControlIcon,
  CustomsDeclarationIcon,
  ConsolidationIcon,
  ParcelRegistrationIcon,
  AdditionalPackagingIcon,
  CustomsDutyIcon,
} from "@/components/assets/icons";
import { ParcelStatus } from "@/enums";

export const additionalServicesIcons = [
  {
    serviceId: 111,
    icon: DeliveryServiceIcon,
  },
  {
    serviceId: 39,
    icon: RepackageIcon,
  },
  {
    serviceId: 201,
    icon: CameraIcon,
  },
  {
    serviceId: 888,
    icon: ReturnIcon,
  },
  {
    serviceId: 1,
    icon: OpenBoxAndSplitIcon,
  },
  {
    serviceId: 2,
    icon: RemoveInvoiceIcon,
  },
  {
    serviceId: 113,
    icon: InsuranceIcon,
  },
  {
    serviceId: 202,
    icon: CheckParcelIcon,
  },
  {
    serviceId: 1403,
    icon: SelfPickUpIcon,
  },
  {
    serviceId: 210,
    icon: PercentIcon,
  },
  {
    serviceId: 209,
    icon: LimitControlIcon,
  },
  {
    serviceId: 208,
    icon: CustomsDeclarationIcon,
  },
  {
    serviceId: 207,
    icon: ConsolidationIcon,
  },
  {
    serviceId: 203,
    icon: ParcelRegistrationIcon,
  },
  {
    serviceId: 205,
    icon: RepackageIcon,
  },
  {
    serviceId: 204,
    icon: AdditionalPackagingIcon,
  },
  { serviceId: 211, icon: CustomsDutyIcon },
];

export const parcelsStatusses = {
  expected: [ParcelStatus.COMMON_STATUS_STATUS_WAITING_TO_RECEIVE],
  warehouse: [
    ParcelStatus.COMMON_STATUS_RECEIVED_AT_THE_INSTOCK,
    ParcelStatus.COMMON_STATUS_PROCESSED_AT_THE_INSTOCK,
    ParcelStatus.COMMON_STATUS_PREPARED_SHIPPING_FROM_FCOUNTRY,
  ],
  inTransit: [
    ParcelStatus.COMMON_STATUS_SHIPPED_FROM_FCOUNTRY,
    ParcelStatus.COMMON_STATUS_RECEIVED_OUTSTOCK,
  ],
  arrived: [
    ParcelStatus.COMMON_STATUS_READY_FOR_PICKUP,
    ParcelStatus.COMMON_STATUS_DELIVERY_REQUEST,
    ParcelStatus.COMMON_STATUS_TRANSFERRED_TO_NATIONAL_CARRIER,
    ParcelStatus.COMMON_STATUS_DELIVERED,
  ],
};

export const deliveryAllowedStatuses = [
  // ParcelStatus.COMMON_STATUS_SHIPPED_FROM_FCOUNTRY,
  ParcelStatus.COMMON_STATUS_RECEIVED_OUTSTOCK,
  ParcelStatus.COMMON_STATUS_READY_FOR_PICKUP,
];
